import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import NotificationCenter from './NotificationCenter';
import { useAuth } from './AuthContext';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';



const Dashboard = () => {
   const auth = useAuth();
  const { keycloak } = useAuth();
  const token = auth?.token;
  const user = auth?.user;
  const tokenParsed = user || {};
  const { t } = useTranslation();
  const userName = keycloak?.tokenParsed?.preferred_username || 'utilisateur';
  const [trending, setTrending] = useState([]);
  const [creators, setCreators] = useState([]);
  const [activities, setActivities] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [showTags, setShowTags] = useState(false);
  const [allTags, setAllTags] = useState([]);
const location = useLocation();
useEffect(() => {
  const params = new URLSearchParams(location.search);
  const filterParam = params.get('filter');
  if (filterParam) {
    setSearchTerm(filterParam);
  }
}, [location.search]);
  const [challenges, setChallenges] = useState([
    {
      id: 1,
      title: "Défi de la semaine",
      description: "Partage une vidéo sur le thème de la nature 🌱",
      deadline: "30 juin 2025"
    },
    {
      id: 2,
      title: "Raconte ta ville",
      description: "Filme ton lieu préféré dans ta ville et raconte pourquoi tu l'aimes.",
      deadline: "5 juillet 2025"
    }
  ]);
  const [projects, setProjects] = useState([]);
  const [likes, setLikes] = useState({});
const filteredProjects = projects.filter(p => {
  const term = (searchTerm || '').toLowerCase();
  const titleMatch = (p.title || '').toLowerCase().includes(term);

  const tagMatch = Array.isArray(p.tags)
    ? p.tags.some(tag => tag.toLowerCase().includes(term))
    : typeof p.tags === 'string' && p.tags.toLowerCase().includes(term);  // ✅ pour les chaînes

  return titleMatch || tagMatch;
});
useEffect(() => {
  document.body.classList.remove('search-overlay'); 
}, []);
console.log("🔎 Filtrage actif pour :", searchTerm);
console.log("📦 Résultats trouvés :", filteredProjects.length);
  const [userSettings, setUserSettings] = useState({
    dashboard_sections: []
  });

  useEffect(() => {
    if (!token) return;
    fetch('/settings', {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
      .then(res => res.json())
      .then(data => {
        let sections = [];

        if (typeof data.dashboard_sections === 'string') {
          try {
            sections = JSON.parse(data.dashboard_sections);
          } catch (e) {
            console.error("❌ dashboard_sections invalid JSON:", data.dashboard_sections);
          }
        } else if (Array.isArray(data.dashboard_sections)) {
          sections = data.dashboard_sections;
        }

       setUserSettings({
  dashboard_sections: sections.length > 0 ? sections : ['latest_videos']
});
      })

      .catch(err => {
        console.error("Erreur chargement paramètres utilisateur :", err);
      });
  }, [keycloak]);

  useEffect(() => {
    setCreators([
      {
        id: "leo",
        name: "Léo",
        avatar: "https://i.pravatar.cc/100?u=leo",
        videos: 24,
        city: "Paris",
        followers: "1.2k"
      },
      {
        id: "emma",
        name: "Emma",
        avatar: "https://i.pravatar.cc/100?u=emma",
        videos: 31,
        city: "Lyon",
        followers: "980"
      },
      {
        id: "yassine",
        name: "Yassine",
        avatar: "https://i.pravatar.cc/100?u=yassine",
        videos: 18,
        city: "Tunis",
        followers: "830"
      },
      {
        id: "sofia",
        name: "Sofia",
        avatar: "https://i.pravatar.cc/100?u=sofia",
        videos: 45,
        city: "Montréal",
        followers: "2.3k"
      },
      {
        id: "julien",
        name: "Julien",
        avatar: "https://i.pravatar.cc/100?u=julien",
        videos: 12,
        city: "Bruxelles",
        followers: "560"
      }, {
        id: "yassine",
        name: "Yassine",
        avatar: "https://i.pravatar.cc/100?u=yassine",
        videos: 18,
        city: "Tunis",
        followers: "830"
      }
    ]);
    setActivities([
      { id: 1, message: "Alice a liké la vidéo de Thomas", time: "il y a 2h" },
      { id: 2, message: "Sophie a rejoint le groupe Nature", time: "il y a 4h" }
    ]);

    fetch('/projects')
      .then((res) => res.json())
      .then((data) => {
        const closed = data.filter(p => p.status === 'Clôturé');
        setProjects(closed);
        const tagsSet = new Set();
        closed.forEach(p => (p.tags || []).forEach(tag => tagsSet.add(tag)));
        setAllTags(Array.from(tagsSet));
        setLikes(Object.fromEntries(closed.map(p => [p.id, false])));
        // vidéos en tendance & suggestions au pif
        setTrending(closed.slice(0, 3));
        setSuggestions(closed.slice(-3));
      })
      .catch(console.error);
  }, []);
  const formatName = (name) => {
    if (!name) return '';
    return name.charAt(0).toUpperCase() + name.slice(1);
  };

  const toggleLike = (id) => {
    setLikes(prev => ({ ...prev, [id]: !prev[id] }));
  };
  const getSharePopoverHtml = (project) => {
    const url = `${window.location.origin}/projects/${project.id}/recap`;
    const encodedUrl = encodeURIComponent(url);

    const icons = [
      {
        name: "WhatsApp",
        href: `https://wa.me/?text=${encodedUrl}`,
        icon: "https://cdn-icons-png.flaticon.com/512/733/733585.png"
      },
      {
        name: "Facebook",
        href: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
        icon: "https://cdn-icons-png.flaticon.com/512/733/733547.png"
      },
      {
        name: "Twitter",
        href: `https://twitter.com/intent/tweet?url=${encodedUrl}`,
        icon: "https://cdn-icons-png.flaticon.com/512/733/733579.png"
      },
      {
        name: "LinkedIn",
        href: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
        icon: "https://cdn-icons-png.flaticon.com/512/733/733561.png"
      },
      {
        name: "Telegram",
        href: `https://t.me/share/url?url=${encodedUrl}`,
        icon: "https://cdn-icons-png.flaticon.com/512/2111/2111646.png"
      },


    ];

    return `
     
    <div style="text-align:center; max-width:300px;">
      <div style="display: grid; grid-template-columns: repeat(4, 1fr); gap: 12px; padding: 6px;">
        ${icons.map(link => `
          <div style="text-align:center;">
            <a href="${link.href}" ${link.onclick ? `onclick="${link.onclick}"` : `target="_blank"`} rel="noopener noreferrer" style="text-decoration:none;">
              <img src="${link.icon}" alt="${link.name}" width="36" height="36" style="border-radius:50%; box-shadow:0 0 3px rgba(0,0,0,0.1);" />
              <div style="font-size:10px; color:#333; margin-top:4px;">${link.name}</div>
            </a>
          </div>
        `).join("")}
      </div>
      <div style="margin-top:8px;">
        <img src="https://api.qrserver.com/v1/create-qr-code/?size=60x60&data=${encodedUrl}" width="60" height="60" alt="QR" style="border-radius:4px;" />
      </div>
    </div>
  `;
  };





  useEffect(() => {
    const popovers = document.querySelectorAll('[data-bs-toggle="popover"]');
    popovers.forEach(el => {
      new window.bootstrap.Popover(el, {
        html: true,
        trigger: 'focus',
        placement: 'top',
      });
    });
  }, [projects]);
  return (
    <div className="container py-4">
      <div className="d-flex justify-content-between align-items-center mb-4">


      </div>
      <br></br>






      {/* 📽️ Dernières vidéos */}

      {userSettings.dashboard_sections.includes('latest_videos') && (
        <>
          {/* 📽️ Dernières vidéos */}
          <section className="mb-5">
            <h4 className="mb-3">📽️ Dernières vidéos</h4>
          <div className="row row-cols-1 row-cols-sm-2 row-cols-md-2 row-cols-lg-3 row-cols-xl-4 g-3">

              {filteredProjects.map((project) => {
                const videoUrl = project.video_url || `/output/project_${project.id}_final.mp4`;
                return (
                  <div className="col" key={project.id}>
                    <div className="card h-100 border-0 shadow rounded-3 bg-white" style={{ transition: 'transform 0.2s', cursor: 'pointer' }}>
                      <div className="position-relative" style={{ paddingBottom: '56.25%', height: 0 }}>
                        <video
                          src={videoUrl}
                          controls
                          className="w-100 h-100 position-absolute top-0 start-0 object-fit-cover"
                          style={{ borderRadius: '12px 12px 0 0' }}
                        />
                      </div>
                      <div className="card-body">
                        <h6 className="fw-bold text-truncate" title={project.title}>{project.title}</h6>
                      </div>
                      <div className="card-footer d-flex justify-content-between align-items-center">

                        <Link to={`/projects/${project.id}/recap`} className="btn btn-sm btn-outline-secondary">
                          📄 Voir détails
                        </Link>
                        <button
                          type="button"
                          className="btn btn-light btn-sm rounded-circle border"
                          data-bs-toggle="popover"
                          data-bs-placement="top"
                          title="Partager"
                          data-bs-html="true"
                          data-bs-content={getSharePopoverHtml(project)}
                        >
                          <i className="bi bi-share-fill"></i>
                        </button>



                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </section>
        </>
      )}
      {/* 🔥 Tendances */}
      {userSettings.dashboard_sections.includes('trending') && (
        <>
          {/* 🔥 Tendances */}
          <section className="mb-5">

            <h4 className="mb-4">🔥 Vidéos en tendance</h4>
            <div className="row row-cols-1 row-cols-md-3 g-4">
              {trending.map(project => (
                <div className="col" key={project.id}>
                  <div className="card h-100 border-0 shadow-sm rounded-4 overflow-hidden bg-white">

                    {/* Thumbnail vidéo */}
                    <div className="ratio ratio-16x9">
                      <video
                        src={`/output/project_${project.id}_final.mp4`}
                        className="w-100 h-100"
                        muted
                        playsInline
                        preload="metadata"
                        style={{ objectFit: 'cover' }}
                        onLoadedMetadata={(e) => { e.currentTarget.currentTime = 0.1 }}
                      />
                    </div>

                    {/* Contenu */}
                    <div className="card-body d-flex flex-column justify-content-between">
                      <h6 className="fw-semibold text-truncate mb-1" title={project.title}>
                        {project.title}
                      </h6>
                      <p className="text-muted small mb-2">👁️ {Math.floor(Math.random() * 1000) + 100} vues</p>
                      <Link
                        to={`/projects/${project.id}/recap`}
                        className="btn btn-sm btn-outline-primary align-self-start"
                      >
                        📺 Voir
                      </Link>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>

        </>
      )}
      {/* 🧑‍🎨 Créateurs */}
      {userSettings.dashboard_sections.includes('creators') && (
        <>
          {/* 🧑‍🎨 Créateurs */}
          <section className="mb-5">
            <h4 className="mb-3">🧑‍🎨 Créateurs en vedette</h4>
         <div className="row row-cols-2 row-cols-sm-3 row-cols-md-4 row-cols-lg-5 g-2">
              {creators.map(user => (
                <div key={user.id} className="col">
                  <Link to={`/users/${user.id}`} className="text-decoration-none">
                    <div
                      className="text-center p-3 rounded shadow-sm bg-white h-100"
                      style={{ transition: 'transform 0.2s' }}
                      onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.03)'}
                      onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}>

                      <img src={user.avatar} alt={user.name} className="rounded-circle mb-2" width="64" height="64" />
                      <h6 className="mb-0">{user.name}</h6>
                      <small className="text-muted d-block">{user.videos} vidéos</small>
                      {user.city && <small className="text-muted d-block">📍 {user.city}</small>}
                      {user.followers && <small className="text-muted d-block">⭐ {user.followers} abonnés</small>}
                    </div>
                  </Link>
                </div>
              ))}
            </div>
          </section>
        </>
      )}

      {/* ⏳ Activité */}
      {userSettings.dashboard_sections.includes('activity') && (
        <>
          {/* ⏳ Activité */}
          <section className="mb-5">
            <h4 className="mb-4">🧵 Activité récente</h4>
            <div className="list-group list-group-flush">
              {activities.map(act => (
                <div key={act.id} className="list-group-item bg-white border rounded shadow-sm mb-2 d-flex align-items-start gap-3 p-3">
                  <div className="bg-info bg-opacity-25 rounded-circle d-flex align-items-center justify-content-center" style={{ width: 40, height: 40 }}>
                    <span style={{ fontSize: '1.2rem' }}>💬</span>
                  </div>
                  <div className="flex-grow-1">
                    <div className="fw-medium">{act.message}</div>
                    <div className="text-muted small">{act.time}</div>
                  </div>
                </div>
              ))}
            </div>
          </section>
        </>
      )}

      {/* 🎯 Défis */}
      {userSettings.dashboard_sections.includes('challenges') && (
        <>
          {/* 🎯 Défis */}
          <section className="mb-5">
            <h4 className="mb-4">🎯 Défis de la communauté</h4>
            <div className="row row-cols-1 row-cols-md-2 g-4">
              {challenges.map(ch => (
                <div key={ch.id} className="col">
                  <div className="bg-white border rounded-4 shadow-sm p-4 d-flex align-items-start gap-3 h-100">
                    {/* Icône visuelle */}
                    <div className="bg-warning bg-gradient text-white d-flex align-items-center justify-content-center rounded-circle shadow-sm" style={{ width: '48px', height: '48px', fontSize: '1.5rem' }}>
                      🏆
                    </div>

                    {/* Contenu principal */}
                    <div className="flex-grow-1 d-flex flex-column justify-content-between">
                      <div>
                        <h6 className="fw-bold mb-1">{ch.title}</h6>
                        <p className="text-muted mb-2" style={{ fontSize: '0.9rem' }}>{ch.description}</p>
                        {ch.deadline && (
                          <p className="text-danger small mb-2">⏳ Jusqu'au : <strong>{ch.deadline}</strong></p>
                        )}
                      </div>

                      <button className="btn btn-sm btn-outline-danger mt-auto align-self-start">
                        🔥 Participer
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>
        </>
      )}

      {/* ✨ Suggestions */}
      {userSettings.dashboard_sections.includes('suggestions') && (
        <>
          {/* ✨ Suggestions */}
          <section>
            <h4 className="mb-3">✨ Tu pourrais aimer...</h4>
            <div className="row g-3">
              {suggestions.map(project => (
              <div key={project.id} className="col-12 col-sm-6 col-md-4">
                  <div className="card p-3 shadow-sm h-100 rounded-3 bg-white border-0">
                    <div key={project.id} className="col">
                      <div className="col">
                        <div className="card border-0 shadow-sm rounded-3 h-100 d-flex flex-column p-2">

                          {/* Miniature vidéo */}
                          <div
                            className="rounded overflow-hidden mb-2"
                            style={{ height: '140px', backgroundColor: '#000' }}
                          >
                            <video
                              src={`/output/project_${project.id}_final.mp4`}
                              className="w-100 h-100"
                              muted
                              playsInline
                              preload="metadata"
                              style={{ objectFit: 'cover' }}
                              onLoadedMetadata={(e) => { e.currentTarget.currentTime = 0.1 }}
                            />
                          </div>

                          {/* Contenu texte et bouton fixé en bas */}
                          <div className="d-flex flex-column flex-grow-1 justify-content-between">
                            <div style={{ minHeight: '60px' }}>
                              <h6 className="fw-semibold text-truncate mb-1" title={project.title}>
                                {project.title}
                              </h6>
                              <p className="text-muted small mb-0 text-truncate">
                                {project.description}
                              </p>
                            </div>
                            <Link
                              to={`/projects/${project.id}/recap`}
                              className="btn btn-sm btn-outline-primary mt-3"
                            >
                              👁️ Voir plus
                            </Link>
                          </div>
                        </div>
                      </div>

                    </div>

                  </div>
                </div>
              ))}
            </div>
          </section>
        </>
      )}
    </div>
  );
};

export default Dashboard;
